import React from 'react';

import PostBetWaitingContent from '../PostBetWaitingContent';

function BetCompletionContent({ responsiveMode, viewProps }) {
  return <PostBetWaitingContent responsiveMode={responsiveMode} viewProps={viewProps} />;
}

export default BetCompletionContent;
